/**
 * Single source of truth for nav + PrivateRoute role gates.
 *
 * Empty array = no role check (any authenticated user may see the nav item).
 * /dashboard stays a public route (no PrivateRoute) so guests can browse;
 * the empty roles entry only controls the logged-in drawer item.
 */
export const ROUTE_ROLES = {
  dashboard: [],
  questionaries: ['manager', 'researcher'],
  localplan: ['manager', 'researcher'],
  sponsors: ['manager', 'sponsor'],
  opportunities: ['manager', 'sponsor'],
  projects: ['manager', 'sponsor'],
  counties: ['manager'],
  questionaryManagement: ['manager'],
  questions: ['manager'],
  admin: ['admin']
};

/** True when allowedRoles is empty/absent, or user has at least one of them. */
export function hasAnyRole(userRoles, allowedRoles) {
  if (!allowedRoles || allowedRoles.length === 0) return true;
  const roles = Array.isArray(userRoles) ? userRoles : [];
  return allowedRoles.some((role) => roles.includes(role));
}
